import { CreateForm, FormFieldsData, FormTemplateProps } from 'framework/form';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import { useEmployeeNoteService } from 'domain/shared/employee';
import NoteForm from 'domain/people/employee/Timeline/note/form/NoteForm';

interface CreateNoteFormProps extends Omit<FormTemplateProps, 'children'> {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
}

const CreateNoteForm = ({ submitFormFunc, onCancel, ...props }: CreateNoteFormProps) => {
  const { getValidationSchema } = useEmployeeNoteService();
  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getValidationSchema} {...props}>
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <NoteForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateNoteForm;
